<app-colored-background [backgroundColor]="'#F89B1C'">
  <app-header [progress]="1" [showProgressIndicator]="false" [title]="locale.currentTranslation.informationHeader"
              [useWhiteFontColor]="true" data-testid="insurance-info-header"></app-header>
  <div>
    <div class="base-content-container" style="gap:8px;" data-testid="insurance-info-container">
      <div>
        <div class="headline1" style="color: #FFFFFF" data-testid="insurance-info-title">
          {{ locale.currentTranslation.whyInsurance }}
        </div>
        <div class="text-body1" style="color: #FFFFFF; margin-top: 8px;">
          <div>
            {{ locale.currentTranslation.insuranceInformation1 }}
          </div>
        </div>
      </div>

    </div>
    <app-finish-box data-testid="finish-box"></app-finish-box>
    <div class="main-button-spacing">
      <button class="main-button" routerLink="/what-is-covered" data-testid="btn-next" role="button" tabindex="0">{{ locale.currentTranslation.next }}</button>
    </div>
  </div>

  <app-footer data-testid="insurance-info-footer"></app-footer>
</app-colored-background>
